import { customerFragment } from "../fragments/customer"

const registerCustomerMutation = /* GraphQL */ `
    mutation registerCustomer($registerCustomerInput: RegisterCustomerInput!) {
        customer {
            registerCustomer(input: $registerCustomerInput) {
                customer {
                    ...customer
                }
                errors {
                    __typename
                    ... on ValidationError {
                        message
                    }
                    ... on CustomerRegistrationError {
                        message
                    }
                    ... on EmailAlreadyInUseError {
                        message
                    }
                    ... on AccountCreationDisabledError {
                        message
                    }
                }
            }
        }
    }
    ${customerFragment}
`
const updateCustomerMutation = /* GraphQL */ `
    mutation updateCustomer($updateCustomerInput: UpdateCustomerInput!) {
        customer {
            updateCustomer(input: $updateCustomerInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const addCustomerAddressMutation = /* GraphQL */ `
    mutation addCustomerAddress($addCustomerAddressInput: AddCustomerAddressInput!) {
        customer {
            addCustomerAddress(input: $addCustomerAddressInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const updateCustomerAddressMutation = /* GraphQL */ `
    mutation updateCustomerAddress($updateCustomerAddressInput: UpdateCustomerAddressInput!) {
        customer {
            updateCustomerAddress(input: $updateCustomerAddressInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const deleteCustomerAddressMutation = /* GraphQL */ `
    mutation deleteCustomerAddress($deleteCustomerAddressInput: DeleteCustomerAddressInput!) {
        customer {
            deleteCustomerAddress(input: $deleteCustomerAddressInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const changePasswordMutation = /* GraphQL */ `
    mutation changePassword($changePasswordInput: ChangePasswordInput!) {
        customer {
            changePassword(input: $changePasswordInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const requestResetPasswordMutation = /* GraphQL */ `
    mutation requestResetPassword($requestResetPasswordInput: RequestResetPasswordInput!) {
        customer {
            requestResetPassword(input: $requestResetPasswordInput) {
                errors {
                    __typename
                    ... on ValidationError {
                        message
                    }
                }
            }
        }
    }
`

const resetPasswordMutation = /* GraphQL */ `
    mutation resetPassword($resetPasswordInput: ResetPasswordInput!) {
        customer {
            resetPassword(input: $resetPasswordInput) {
                customer {
                    ...customer
                }
            }
        }
    }
    ${customerFragment}
`

const loginMutation = /* GraphQL */ `
    mutation login($email: String!, $password: String!) {
        login(email: $email, password: $password) {
            customer {
                ...customer
            }
        }
    }
    ${customerFragment}
`

const logoutMutation = /* GraphQL */ `
    mutation logout {
        logout {
            result
        }
    }
`

export {
    registerCustomerMutation,
    updateCustomerMutation,
    addCustomerAddressMutation,
    updateCustomerAddressMutation,
    deleteCustomerAddressMutation,
    changePasswordMutation,
    requestResetPasswordMutation,
    resetPasswordMutation,
    loginMutation,
    logoutMutation,
}
